/**
 * welcomeContact.js — TEST 3.01 interim (Alex, 2026-10-02 Q8), patient 242.229.0.
 *
 * Onboarding step 1 (OnboardingWelcome) let the patient edit Email and Mobile, but the change
 * never reached the account: orella-api update_profile mirrors only the first and last name from
 * identification into the users row, and login, e-mail, SMS and 2FA read the users row. So the
 * two fields are READ-ONLY and show the account's own values.
 *
 * A field is locked only when the account holds a value the step would accept, so a locked field
 * can never hold Continue back:
 *   - email: a well-formed address that is not an Apple private relay (the relay keeps its
 *     existing "add a real email" path, which feeds the case PDF's contact line);
 *   - phone: a number PHONE_RE accepts.
 * An account with no such value (none on file, or a relay address) keeps the field editable.
 */
export const PRIVATE_RELAY_RE = /@privaterelay\.appleid\.com$/i
export const PHONE_RE = /^[\d\s().+-]{7,}$/
export const EMAIL_RE = /\S+@\S+\.\S+/

export function accountContact(account) {
  const a = account || {}
  const email = String(a.email || '').trim()
  const phone = String(a.phone || '').trim()
  return {
    email,
    phone,
    emailLocked: EMAIL_RE.test(email) && !PRIVATE_RELAY_RE.test(email),
    phoneLocked: PHONE_RE.test(phone),
  }
}
